import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var productList = new Swiper(".section5 .swiper", {
    slidesPerView: 3,
    spaceBetween: 19,
    navigation: {
        nextEl: ".section5 .swiper-button-next",
        prevEl: ".section5 .swiper-button-prev",
    },
    breakpoints: {
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            spaceBetween: 19,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1,
            spaceBetween: 10,
        }
    } 
});